import { contentApi } from "@/api/content-api";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./notice-tip-modal.css";
import { useNoticeStore } from "./notice-store";

export default function NoticeTipModal() {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18n")
    ? localStorage.getItem("i18n")
    : "en";
  const [content, setContent] = useState({});
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const loadContentList = async () => {
    try {
      const data = await contentApi.list({ pageNum: 1, pageSize: 1 });
      if (data?.ok && data?.data?.records) {
        const records = data.data.records;
        if (Array.isArray(records) && records.length > 0) {
          setContent(records[0] || {});
        }
      }
    } catch (error) {
      console.error("Failed to load content:", error);
    }
  };

  const contentData = useMemo(() => {
    return content[
      language === "zh"
        ? "content"
        : `content${language[0].toUpperCase()}${language[1]}`
    ];
  }, [content, language]);

  useEffect(() => {
    loadContentList();
  }, []);

  const { hasShowNotice, setHasShowNotice } = useNoticeStore();

  useEffect(() => {
    if (contentData && !hasShowNotice) {
      setShowModal(true);
      setHasShowNotice(true);
    }
  }, [contentData]);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleConfirm = () => {
    setShowModal(false);
    navigate("/chat");
  };

  if (!showModal || !contentData) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center animate-fade-in">
      {/* Background overlay */}
      <div className="absolute inset-0" />

      {/* Modal content */}
      <div className="relative bg-white rounded-2xl shadow-2xl mx-4 max-w-sm w-full modal-content animate-zoom-in">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors duration-200 group"
          aria-label="Close modal"
        >
          <svg
            className="w-4 h-4 text-gray-600 group-hover:text-gray-800"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Icon */}
        <div className="flex justify-center pt-8 pb-4">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center relative">
            {/* Diamond icon with warning */}
            <svg
              className="w-8 h-8 text-gray-600"
              fill="currentColor"
              viewBox="0 0 24 24"
            >
              <path d="M12 2L2 7L12 12L22 7L12 2Z" opacity="0.6" />
              <path d="M2 17L12 22L22 17" />
              <path d="M2 12L12 17L22 12" />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="px-8 pb-6">
          <div className="text-gray-800 text-center leading-relaxed whitespace-pre-line text-base">
            {contentData}
          </div>
        </div>

        {/* Confirm Button */}
        <div className="px-8 pb-8">
          <button
            onClick={handleConfirm}
            className="w-full bg-primary text-white font-medium py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl"
          >
            {t("客服咨询")}
          </button>
        </div>
      </div>
    </div>
  );
}
